interface ArtefactRow {
  id: string;
  title: string;
  kind: string;
}

interface AiArtefactsRailProps {
  artifacts: ArtefactRow[];
  onOpen: (id: string) => void;
}

export function AiArtefactsRail({ artifacts, onOpen }: AiArtefactsRailProps) {
  if (artifacts.length === 0) return null;
  return (
    <aside className="hidden w-64 shrink-0 flex-col gap-2 rounded-soft-md border border-border bg-surface p-3 lg:flex">
      <h2 className="text-sm font-medium text-fg">Artefacts</h2>
      <ul className="space-y-0.5 overflow-y-auto text-sm">
        {artifacts.map((a) => (
          <li key={a.id}>
            <button
              type="button"
              className="w-full truncate rounded-soft-md px-2 py-1.5 text-left text-fg hover:bg-muted"
              onClick={() => onOpen(a.id)}
            >
              {a.kind === "interactive" ? (
                <span className="mr-1 text-[10px] uppercase tracking-wide text-muted-fg">live</span>
              ) : null}
              {a.title}
            </button>
          </li>
        ))}
      </ul>
    </aside>
  );
}
